import { render, staticRenderFns } from "./MatchWinloseDetail.vue?vue&type=template&id=157a11a6&"
import script from "./MatchWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./MatchWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports